import { render, staticRenderFns } from "./SeguimientoOT.vue?vue&type=template&id=2d0135b8&scoped=true"
import script from "./SeguimientoOT.vue?vue&type=script&lang=js"
export * from "./SeguimientoOT.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoOT.vue?vue&type=style&index=0&id=2d0135b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0135b8",
  null
  
)

export default component.exports